import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-session-warning-modal',
  templateUrl: './session-warning-modal.component.html',
  styleUrls: ['./session-warning-modal.component.scss'],
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class SessionWarningModalComponent {
  @Input() isVisible = false;
  @Input() timeLeft = 0;
  @Output() continue = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  onContinue(): void {
    this.continue.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }

  get timeLeftFormatted(): string {
    if (this.timeLeft <= 0) return '0s';
    if (this.timeLeft < 60) {
      return `${this.timeLeft}s`;
    }
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${minutes}m ${seconds}s`;
  }
}
